import { prefixerT } from '.'

export const ROUTE_BANDEJA_REEMBOLSO_INTERNO = prefixerT('bandeja-reembolso-interno')
export const ROUTE_REEMBOLSO_INTERNO = prefixerT('reembolso-interno')
export const ROUTE_APROBACION_REEMBOLSO_INTERNO = prefixerT('aprobacion-reembolso-interno')
export const ROUTE_BANDEJA_ORDEN_PAGO = prefixerT('bandeja-orden-pago')
export const ROUTE_ORDEN_PAGO_SIN_FLUJO = prefixerT('orden-pago-sin-flujo')
export const ROUTE_ASIGNACION_ORDEN_ENTREGA = prefixerT('asignacion-ordenes-entrega')
export const ROUTE_BANDEJA_REGISTRO_DOCUMENTO = prefixerT('bandeja-registro-documento')
export const ROUTE_REGISTRO_DOCUMENTO = prefixerT('registro-documento')
export const ROUTE_APROBACION_REGISTRO_DOCUMENTO = prefixerT('aprobacion-registro-documento')
export const ROUTE_APROBACION_CRUCE_REGDOC = prefixerT('aprobacion-cruce-regdoc')
export const ROUTE_BANDEJA_ABONOS = prefixerT('bandeja-abonos')
export const ROUTE_CREAR_ABONO = prefixerT('crear-abono')
export const ROUTE_BANDEJA_ANTICIPOS = prefixerT('bandeja-anticipos')
export const ROUTE_CREAR_ANTICIPO = prefixerT('crear-anticipo')
export const ROUTE_APROBACION_ANTICIPOS = prefixerT('aprobacion-anticipos')
export const ROUTE_NOTA_CREDITO = prefixerT('nota-credito')
export const ROUTE_NOTA_DEBITO = prefixerT('nota-debito')
export const ROUTE_LIQUIDACION_EMBARQUES = prefixerT('liquidacion-embarques')
export const ROUTE_BANDEJA_NOTA_CREDITO = prefixerT('bandeja-nota-credito')
export const ROUTE_ASIGNACION_TAREAS = prefixerT('asignacion-tareas')
export const ROUTE_BANDEJA_GASTOS_IMPORTACIONES_POR_REGISTRAR = prefixerT('bandeja-importaciones')

export const ROUTE_LIQUIDACION_COMPRA_SERVICIO = 'cuentas-x-pagar:transacciones:liquidacion-compra-servicio'
export const ROUTE_BANDEJA_LIQUIDACION_COMPRA_SERVICIO =
    'cuentas-x-pagar:transacciones:bandeja-liquidacion-compra-servicio'
